var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotlocated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.41,
    height: 14.41,
    viewBox: "0 0 14.41 14.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44950",
    "data-name": "Group 44950",
    transform: "translate(-834 -187.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-disabled",
    "data-name": "Icon material-location-disabled",
    d: "M14.394,7.883a5.891,5.891,0,0,0-5.2-5.2V1.333H7.883V2.683a5.734,5.734,0,0,0-2.07.635L6.8,4.3a4.578,4.578,0,0,1,6.327,4.238,4.606,4.606,0,0,1-.341,1.736l.982.982A5.925,5.925,0,0,0,14.4,9.193h1.343V7.883H14.394ZM2.643,3.475,3.98,4.811a5.839,5.839,0,0,0-1.3,3.072H1.333v1.31H2.683a5.891,5.891,0,0,0,5.2,5.2v1.349h1.31V14.394a5.891,5.891,0,0,0,3.072-1.3L13.6,14.433l.832-.832L3.475,2.643Zm8.692,8.692A4.581,4.581,0,0,1,4.91,5.741l6.426,6.426Z",
    transform: "translate(832.667 186.002)",
    fill: "#ef476f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotlocated);
export default __webpack_public_path__ + "static/media/notlocated.d1a162c9d80a6f0065b3f9da0bb837cb.svg";
export { ForwardRef as ReactComponent };